import { useContext } from 'react';
import { CurrencyContext } from '../App';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { CURRENCY_OPTIONS } from '../utils/currency';

const CurrencySelector = () => {
  const { currency, switchCurrency } = useContext(CurrencyContext);
  const current = CURRENCY_OPTIONS.find((item) => item.code === currency) || CURRENCY_OPTIONS[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="text-white/70 hover:bg-white/5 hover:text-green-400 flex items-center gap-1 p-1.5 md:p-2"
          data-testid="currency-switcher"
        >
          <span className="text-[10px] sm:text-xs font-semibold">{current.code}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44 bg-gray-900 border-white/10">
        {CURRENCY_OPTIONS.map((item) => (
          <DropdownMenuItem
            key={item.code}
            onClick={() => switchCurrency(item.code)}
            className={`cursor-pointer text-gray-300 hover:text-green-400 ${currency === item.code ? 'bg-white/5' : ''}`}
            data-testid={`currency-${item.code}`}
          >
            <span className="font-semibold">{item.code}</span>
            <span className="ml-auto text-white/40 text-xs">{item.name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default CurrencySelector;
